import React from 'react'
import { useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import NormalLayoutContainer from '../../../shared/NormalLayoutContainer'
import { PageTitle } from '../../../../components/page-title'
import { Spinner } from '../../../shared/Spinner'
import SiteTypesList from './components/SiteTypesList'
import useQuery from '../../../../hooks/useQuery'
import QUERY_KEYS from '../../../../graphql/queryKeys'
import siteTypesQuery from '../../../../graphql/queries/siteTypes'
import { captureErrorAndNotify } from '../../../../utilities/errorHandlers'

export default function HaulerSiteTypesContainer () {
  const history = useHistory()
  const { user } = useSelector(({ user: { user, hauler } }) => ({ user, hauler }))

  const onEdit = (id) => {
    history.push(`/hauler/site-types/${id}/edit`)
  }

  const addNewSiteType = () => {
    history.push('/hauler/site-types/new')
  }

  const { data: siteTypesData, isLoading: siteTypesLoading } = useQuery(
    [
      QUERY_KEYS.siteTypes,
      user.haulerId
    ],
    siteTypesQuery,
    {
      onError (error) {
        captureErrorAndNotify(error, 'Failed to retrieve site types')
      }
    }
  )

  if (siteTypesLoading) return <Spinner isFetching />

  return (
    <div>
      <NormalLayoutContainer>
        <div className='container-fluid'>
          <PageTitle title='Site Types'>
            <button
              className='btn btn-lg btn-primary pull-right push-down-super-small'
              onClick={addNewSiteType}>
              <span className='pull-left hidden-xs'>New Site Type</span>
              <i className='material-icons pull-right thumbster-button-icon no-margin-bs-xs'>add_circle</i>
            </button>
          </PageTitle>
          <div>
            <SiteTypesList
              siteTypes={siteTypesData.siteTypes ?? []}
              onEdit={onEdit}
            />
          </div>
        </div>
      </NormalLayoutContainer>
    </div>
  )
}
